import FileViewer from "react-native-file-viewer"
import fs from "./fs"
import { Platform } from "react-native"

export default function fileService() {
  const saveFile = async (fileName: string, fileContent: string) => {
    const filePath = fs.DocumentDirectoryPath + "/" + fileName
    await fs.writeFile(filePath, fileContent, "base64")
    return filePath
  }

  const openFile = (filePath: string, successCallback?: () => void) => {
    if (Platform.OS !== "web") {
      FileViewer.open(filePath, { showOpenWithDialog: true }).then(successCallback)
    } else {
      if (successCallback) successCallback()
    }
  }

  return { saveFile, openFile }
}
